import { createFileRoute } from '@tanstack/react-router';
import { BrandingPage } from '@/features/organization/branding/branding-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/branding')({
    staticData: { crumbs: [{ label: 'settings.nav.branding' }] },
    component: function BrandingRoute() {
        const { organizationId } = Route.useParams();
        return <BrandingPage organizationId={organizationId} />;
    },
});
